import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { DetailInfoComponentModel } from "../../models/components.model";
import DocumentInfoComponent from "../detailInfo/documentInfoComponent";
import NoImageFoundDocument from "./noImageFoundDocument";

export default function DetailInfoComponentThumbnail({
  sections,
  data,
  documentList,
  title,
  height,
  addressByInquiry,
  showFooter,
  showDoc,
  modal,
  isGuarantor,
  compareHistory,
}: DetailInfoComponentModel) {
  const [detailSections, setDetailSections] = useState(sections);
  useEffect(() => {
    setDetailSections(sections);
  }, [sections]);
  const [detailData, setDetailData] = useState(data);
  useEffect(() => {
    setDetailData(data);
  }, [data]);
  return (
    // <div className="row mTop20">
    <>
      <Grid container xs={12}>
        <Grid
          container
          xs={11}
          spacing={{ xs: 2, md: 3 }}
          columns={{ xs: 4, sm: 8, md: 12 }}
          style={
            !isGuarantor
              ? { marginTop: "0.5vh", marginBottom: "5vh" }
              : { marginTop: "0.5vh" }
          }
        >
          {detailSections.map((section) => {
            let value = detailData && detailData[section.dataKey!];

            if (section.dataKey == "deliveryTime") {
              let deliveryTime = detailData["deliveryDate_Persian"].split(" ");
              if (
                deliveryTime != undefined &&
                deliveryTime != null &&
                deliveryTime.length > 0
              ) {
                value = deliveryTime[1];
              }
            } else if (section.dataKey == "deliveryDate_Persian") {
              let deliveryTime = detailData["deliveryDate_Persian"].split(" ");
              if (
                deliveryTime != undefined &&
                deliveryTime != null &&
                deliveryTime.length > 0
              ) {
                value = deliveryTime[0];
              }
            } else if (value && section.hasThousandSeparatorFormat) {
              value = value.toLocaleString("fa");
            }
            return (
              <Grid
                className="confirm"
                item
                xs={section.rowCol}
                sm={4}
                md={section.rowCol}
                // columns={{ xs: 4, sm: 6, md: 12 }}
                style={{ marginRight: "-4vh", whiteSpace: "nowrap" }}
              >
                <Typography className="divRequestDetail ">
                  <span className="secColor"> {section.title}: </span>
                  <span
                    className="fontBlueColor textFont14 fontWeight"
                    style={
                      { overflowWrap: "anywhere" } &&
                      section.dataKey == "inquiryDueDatePersian" &&
                      compareHistory == true
                        ? {
                            backgroundColor: "#ee9d01",
                            color: "#fff",
                            borderRadius: "5px",
                            paddingRight: "5px",
                            paddingLeft: "5px",
                          }
                        : section.dataKey == "inquiryDueDatePersian" &&
                          compareHistory == false &&
                          value!
                        ? {
                            backgroundColor: "#28a745",
                            color: "#fff",
                            borderRadius: "5px",
                            paddingRight: "5px",
                            paddingLeft: "5px",
                          }
                        : { backgroundColor: "#fff" }
                    }
                  >
                    {value} {section.dataPostValue}
                  </span>
                </Typography>
              </Grid>
            );
          })}
        </Grid>
        {modal ? (
          <Grid item xs={1}>
            <Typography
              className="divRequestDetail "
              style={{ paddingTop: "2vh" }}
            >
              {modal}
            </Typography>
          </Grid>
        ) : (
          ""
        )}
      </Grid>

      {documentList!.length > 0 ? <hr /> : ""}
      {/* {documentList ? <hr /> : ""} */}

      <Grid
        container
        xs={12}
        spacing={2}
        columns={{ xs: 2, sm: 8, md: 12 }}
        // color={`${workflowStepType == "Forward" ? "#28A745" : "#e6123d"}`}
        style={{ paddingRight: "5vh", direction: "rtl" }}
        className={`${isGuarantor == true ? "directionLTR" : "directionRTL"}`}
      >
        {showDoc == undefined || showDoc == true
          ? documentList?.map((item: any) => (
              <Grid item xs={2}>
                {item?.fileUrl ? (
                  <DocumentInfoComponent
                    data={item}
                    title={isGuarantor ? item.documentTypeTitle : title}
                    showFooter={showFooter}
                    height={height}
                    isGuarantor={isGuarantor ? isGuarantor : false}
                  />
                ) : (
                  <NoImageFoundDocument />
                )}
              </Grid>
            ))
          : null}
      </Grid>

      {addressByInquiry &&
      data?.addressByInquiry != undefined &&
      data?.addressByInquiry != null &&
      data?.addressByInquiry != "" ? (
        <Grid className="confirm centerVertical" xs={12}>
          <div
            style={{
              width: "100%",
              background: "#E5F7EC",
              padding: "1.2vh",
              // marginBottom: "2vh",
              // border: "solid #707070 .5px",
              boxShadow:
                "0 0px 1.1px 0 rgba(0, 0, 0, 0), 0 1.1px 1.1px 0 rgba(0, 0, 0, 0.5)",
              borderRadius: "5px",
            }}
            className="centerVertical"
          >
            <b style={{ color: "#01AF43", fontSize: "1em" }}>
              &nbsp;&nbsp; <CheckCircleIcon /> استعلام آدرس از سامانه پست انجام
              شد.
            </b>{" "}
            &nbsp;&nbsp;
            <b style={{ color: "##212121", fontSize: "1em" }}>
              &nbsp;&nbsp; | &nbsp;&nbsp; &nbsp;&nbsp;{data?.addressByInquiry!}
              &nbsp;&nbsp;
            </b>
          </div>
        </Grid>
      ) : null}
    </>
  );
}
